function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipRule: "evenodd",
  fill: "rgb(0,0,0)",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m4.5 3.75c-.41421 0-.75.33579-.75.75v15c0 .4142.33578.75.75.75h15c.4142 0 .75-.3358.75-.75v-9.5c0-.41421.3358-.75.75-.75s.75.33579.75.75v9.5c0 1.2427-1.0073 2.25-2.25 2.25h-15c-1.24263 0-2.25-1.0073-2.25-2.25v-15c0-1.24264 1.00736-2.25 2.25-2.25h10.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75z"
}), React.createElement("path", {
  d: "m20.9359 2.8897c.3371.24076.4152.70917.1744 1.04623l-7.5 10.49997c-.1197.1677-.3032.2787-.5072.307s-.4108-.0286-.5716-.1572l-5.00002-4c-.32345-.2588-.37589-.73077-.11713-1.05422s.73072-.37589 1.05417-.11713l4.38158 3.50525 7.0396-9.85553c.2408-.33706.7092-.41513 1.0462-.17437z"
}));

var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.7f5f949e.svg";
export { ForwardRef as ReactComponent };